module.exports = __webpack_public_path__ + "media/images/banner/wowjapan/sidebar/zh-hans-c9bcc5879cde77920bfb5ab9396b6aea.jpg";